import React, { useLayoutEffect, useRef, useState } from 'react';

const Tooltip = ({ target, children, mobileMode, onClose }) => {
  const tooltipRef = useRef(null);
  const [style, setStyle] = useState({ visibility: 'hidden' });

  useLayoutEffect(() => {
    if (mobileMode) {
      setStyle({ visibility: 'visible' });
      return;
    }

    if (tooltipRef.current && target) {
      const targetRect = target.getBoundingClientRect();
      const tooltipRect = tooltipRef.current.getBoundingClientRect();
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      let top = targetRect.bottom + 10;
      let left = targetRect.left;

      // If it goes off the bottom, move it to the top
      if (top + tooltipRect.height > windowHeight) {
        top = targetRect.top - tooltipRect.height - 10;
      }

      // If it goes off the right, align the right edges
      if (left + tooltipRect.width > windowWidth) {
        left = windowWidth - tooltipRect.width - 10;
      }

      // If it goes off the left, align the left edges
      if (left < 0) {
        left = 10;
      }

      setStyle({ top, left, visibility: 'visible' });
    }
  }, [target, children, mobileMode]);

  if (mobileMode) {
    return (
      <div className="tooltip-overlay" onClick={(e) => {
        e.stopPropagation();
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}>
        <div className="recipe-tooltip mobile-centered" onClick={(e) => e.stopPropagation()}>
          {children}
        </div>
      </div>
    );
  }

  return (
    <div ref={tooltipRef} className="recipe-tooltip" style={style}>
      {children}
    </div>
  );
};

export default Tooltip;